import { ModalBody } from "@nextui-org/react";
import styles from "./AllariaMasBody.module.scss";
import unifiedIllustration from "../../../../assets/images/illustrations/unified-image.svg";
import Alert from "../../../Alert/Alert";
import useScreenSize from "../../../../hooks/useScreenSize";

const AllariaMasBody = () => {
  const { bodyContainer, pill, promoSection, alert, titleRow } = styles;
  const { isMobile } = useScreenSize();
  return (
    <ModalBody className={`${bodyContainer} m-0 ${isMobile ? "px-6 pt-6" : "px-10 pt-10"} pb-0`}>
      <section>
        <div className={`${titleRow} ${isMobile ? "flex-col items-start" : ""}`}>
          <h1>Unificá tus saldos</h1>
          <div className={pill}>
            <h2>Obtené beneficios exclusivos</h2>
          </div>
        </div>
        <div className={isMobile ? "" : "grid grid-cols-2 gap-x-10 items-center"}>
          <article>
            <div className={promoSection}>
              <h3>Recibí dinero de terceros</h3>
              <p>
                Cobrá con transferencias, links de pago, QRs y débitos
                automáticos.
              </p>
            </div>
            <div className={promoSection}>
              <h3>Gestioná tus pagos</h3>
              <p>Distribuí y limitá gastos con tarjetas.</p>
              <p>Programá transferencias y pagos.</p>
            </div>
          </article>
          {!isMobile && <img src={unifiedIllustration} alt="Allaria+" />}
        </div>
      </section>
      <section>
        <Alert className={alert} variant="INFO">
          <p>
            Si no tenés cuenta en Allaria+ podrás crear una y unificarla con
            Allaria.
          </p>
        </Alert>
      </section>
    </ModalBody>
  );
};

export default AllariaMasBody;
